import { useEffect, useState } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-5 z-40 w-11 h-11 rounded-full bg-foreground-950 text-background-50 flex items-center justify-center text-xl hover:bg-primary-600 transition-colors"
    >
      <i className="ri-arrow-up-line" aria-hidden="true"></i>
    </button>
  );
}